export const mediaDeviceService = {
  enumerate: () => navigator.mediaDevices.enumerateDevices(),
  cameras: async () => (await navigator.mediaDevices.enumerateDevices()).filter((device) => device.kind === "videoinput"),
  microphones: async () => (await navigator.mediaDevices.enumerateDevices()).filter((device) => device.kind === "audioinput"),
  speakers: async () => (await navigator.mediaDevices.enumerateDevices()).filter((device) => device.kind === "audiooutput"),
};
